import {RouterModule, Routes}                        from '@angular/router';
import {AuthenticationService}                       from '../shared/authentication.service';
import {CompaniesResolver}                           from '../shared/resolvers/companies.resolver';
import {UsersResolver}                               from '../shared/resolvers/users.resolver';
import {LanguagesGroupedResolver, LanguagesResolver} from '../shared/languages.resolver';
import {CanDo}                                       from '../shared/CanDo';
import {Permission}                                  from '../shared/api/permissions/api.models';
import {PermissionsResolver}                         from '../shared/resolvers/permissions.resolver';
import {SettingsLanguagesComponent}                  from './languages/languages.component';
import {CompaniesComponent}                          from './companies/companies.component';
import {RolesComponent}                              from './roles/roles.component';
import {SettingsUsersComponent}                      from './users/users.component';
import {RolesResolver}                               from '../shared/resolvers/roles.resolver';
import {MessagecentralsComponent}                    from './messagecentrals/messagecentrals.component';
import {MessagecentralsResolver}                     from '../shared/resolvers/messagecentrals.resolver';
import {BasesComponent}                              from './bases/bases.component';
import {BasesResolver}                               from '../shared/resolvers/bases.resolver';
import {Base}                                        from '../shared/api/bases/api.models';

const routes: Routes = [
    {
        path : 'settings/languages',
        component : SettingsLanguagesComponent,
        resolve: {
            languages: LanguagesResolver
        },
        canActivate : [AuthenticationService, CanDo],
        data : {
            canDo : [
                Permission.LANGUAGES_WRITE
            ]
        }
    },
    {
        path : 'settings/users',
        component : SettingsUsersComponent,
        resolve: {
            users: UsersResolver,
            roles: RolesResolver,
            companies: CompaniesResolver,
            languages: LanguagesResolver
        },
        canActivate : [AuthenticationService, CanDo],
        data : {
            canDo : [
                Permission.USERS_WRITE,
                Permission.USERS_WRITE_ALL
            ]
        }
    },
    {
        path : 'settings/roles',
        component : RolesComponent,
        resolve: {
            roles: RolesResolver,
            permissions: PermissionsResolver
        },
        canActivate : [AuthenticationService, CanDo],
        data : {
            canDo : [
                Permission.ROLES_WRITE
            ]
        }
    },
    {
        path : 'settings/companies',
        component : CompaniesComponent,
        resolve: {
            companies: CompaniesResolver
        },
        canActivate : [AuthenticationService, CanDo],
        data : {
            canDo : [
                Permission.COMPANIES_WRITE
            ]
        }
    },
    {
        path: 'settings/messagecentrals',
        component: MessagecentralsComponent,
        resolve: {
            messagecentrals: MessagecentralsResolver,
            languages: LanguagesGroupedResolver
        },
        canActivate: [AuthenticationService, CanDo],
        data: {
            allLanguages: true,
            canDo : [
                Permission.MESSAGECENTRAL_WRITE
            ]
        }
    },
    {
        path: 'settings/bases',
        component: BasesComponent,
        resolve: {
            bases: BasesResolver
        },
        canActivate: [AuthenticationService, CanDo],
        data: {
            type: Base.TYPE_CHATOMATIC,
            canDo : [
                Permission.BASES_WRITE
            ]
        }
    }
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/settings.routing.ts